export const FETCH_RAW_STOCK_CODES_REQUEST = 'FETCH_RAW_STOCK_CODES_REQUEST';
export const FETCH_RAW_STOCK_CODES_SUCCESS = 'FETCH_RAW_STOCK_CODES_SUCCESS';
export const FETCH_RAW_STOCK_CODES_FAILURE = 'FETCH_RAW_STOCK_CODES_FAILURE';
export const CREATE_RAW_STOCK_CODE_REQUEST = 'CREATE_RAW_STOCK_CODE_REQUEST';
export const CREATE_RAW_STOCK_CODE_SUCCESS = 'CREATE_RAW_STOCK_CODE_SUCCESS';
export const CREATE_RAW_STOCK_CODE_FAILURE = 'CREATE_RAW_STOCK_CODE_FAILURE';
export const UPDATE_RAW_STOCK_CODE_REQUEST = 'UPDATE_RAW_STOCK_CODE_REQUEST';
export const UPDATE_RAW_STOCK_CODE_SUCCESS = 'UPDATE_RAW_STOCK_CODE_SUCCESS';
export const UPDATE_RAW_STOCK_CODE_FAILURE = 'UPDATE_RAW_STOCK_CODE_FAILURE';
export const DELETE_RAW_STOCK_CODE_REQUEST = 'DELETE_RAW_STOCK_CODE_REQUEST';
export const DELETE_RAW_STOCK_CODE_SUCCESS = 'DELETE_RAW_STOCK_CODE_SUCCESS';
export const DELETE_RAW_STOCK_CODE_FAILURE = 'DELETE_RAW_STOCK_CODE_FAILURE';
export const CREATE_RAW_STOCK_CODE = 'CREATE_RAW_STOCK_CODE';
export const UPDATE_RAW_STOCK_CODE = 'UPDATE_RAW_STOCK_CODE';
export const DELETE_RAW_STOCK_CODE = 'DELETE_RAW_STOCK_CODE';
export const SET_SELECTED_RAW_STOCK_CODE = 'SET_SELECTED_RAW_STOCK_CODE';
export const CLEAR_SELECTED_RAW_STOCK_CODE = 'CLEAR_SELECTED_RAW_STOCK_CODE'; 